<template>
    <div class="missed-payment">
        <b-card no-body>
            <b-card-header class="py-2 px-3">
                <!-- <h3 class="mb-0">Missed payment history</h3> -->
                 <b-row align-v="center">
                    <b-col cols="6">
                        <h3 class="mb-0">
                           Missed payment history
                        </h3>
                    </b-col>
                    <b-col cols="6" class="text-right">
                        <b-link href="javascript:void(0)" @click="modals.show_missed_pay_full_view = true">
                            <b-icon icon="eye-fill" variant="primary"></b-icon>
                            Full View
                        </b-link>
                    </b-col>
                </b-row>  
            </b-card-header>
            <div v-if="tableData.length > 0" class="rounded-bottom">
                <el-table
                :data="tableData"
                style="width: 100%">
                    <el-table-column
                        label="Date/Facility Type"
                        min-width="210"
                        width="auto">
                        <template slot-scope="scope">
                            <p class="mb-0 top-line">{{ scope.row.missed_pay_approved_date }}</p>
                            <p class="text-uppercase mb-0">{{ scope.row.missed_pay_loan_statue }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="missed_pay_credit_limit"
                        label="Limit (RM)"
                        min-width="150"
                        width="auto">
                        <template slot-scope="scope">
                            <p class="top-line">{{ scope.row.missed_pay_credit_limit | moneyFormatter }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="missed_pay_payment_history"
                        label="Payment History"
                        min-width="200"
                        width="auto">
                        <template slot-scope="scope">
                            <p class="top-line">{{ scope.row.missed_pay_payment_history }}</p>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-else class="bg-light p-3 text-center rounded-bottom">
                <p class="text-xs">No Misses Payment History recorded</p>
            </div>
        </b-card>
          <MissedPaymentModal
            :missed-payment-history="missedPaymentHistory"
            :loan-commitment="loanCommitment"  
            :show_missed_pay_full_view.sync="modals.show_missed_pay_full_view"
          />
    </div>
</template>
<script>
    import { Card, Button, Table, TableColumn } from 'element-ui'
    import MissedPaymentModal from '@/views/CustomerProfile/CustomerModals/MissedPaymentModal.vue'

    export default {
        name: 'missed-payment',
        props: {
          missedPaymentHistory: Array,
          loanCommitment: [Array, Object],
        },
         components: {
            MissedPaymentModal,
            [Card.name]: Card,
            [Button.name]: Button,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
        },
        data() {
            return {
                tableData: this.missedPaymentHistory,
                 modals: {
                  show_missed_pay_full_view: false
                }
            }
        },
    }
</script>